import React, { useState, useEffect, useMemo, FormEvent } from "react";
import { Dropdown } from "@fluentui/react/lib/Dropdown";
import {Stack } from "@fluentui/react/lib/Stack";
import { FontIcon, Label, mergeStyles } from "@fluentui/react";

const LargeFormSelect = (props) => {
  const iconClass = mergeStyles({
    fontSize: 8,
    height: 8,
    width: 8,
    margin: '0',
    position: 'absolute',
    color: 'var(--color-primary)' 
  });
  const [selectedItem, setSelectedItem] = useState();
  const [valInp, setValInp] = useState(null)
  const [dropdownValue, setDropdownValue] = useState(null)
  const [multiSelectSelectedKeys, setMultiSelectSelectedKeys] = useState(props.defaultSelectedKeys || [])
  let item = props.item;
  const controlsPage = props.props.controlsPage;
  if (item.defaultValue) {
    if (Array.isArray(item.defaultValue)) {
      item.defaultValue.map(obj=>{
        
        
        
      })
    }
  }
  //#region  Buscar en un arreglo el id para habilitar y deshabilitar
  let found;
  if (props.isDisableOpt.length === 1) {
    found = props.isDisableOpt.find(
      (element) => element.key === "valueDefault"
    );
  } else {
    found = props.isDisableOpt.find((element) => element.key === item.key);
    if (found === undefined) {
      found = props.isDisableOpt.find(
        (element) => element.key === "valueDefault"
      );
    }
  }
  if (found === undefined) {
    found = props.isDisableOpt.find((element) => element.key === item.key);
  }

  useEffect(() => {
    if (item.defaultValue !== null) {
      // Usar setTimeout para evitar ResizeObserver
      const timer = setTimeout(() => {
        setDropdownValue(item.defaultValue)
        if(item.key=='isPrimary'&& !item.defaultValue){
          setDropdownValue(true)
        }
      }, 0);
      
      return () => clearTimeout(timer);
    }
  }, [item.defaultValue])

  useEffect(() => {
  }, [dropdownValue])

  useEffect(() => {
    if (props.item && props.item.multiSelect && props.defaultSelectedKeys) {
      setMultiSelectSelectedKeys(props.defaultSelectedKeys);
    }
  }, [props.defaultSelectedKeys]);

  //#endregion
  //#region Accion onChange
  const onChange = (e, changedItem) => {
    if (item.multiSelect) {
      setMultiSelectSelectedKeys(prev =>
        changedItem.selected
          ? [...prev, changedItem.key]
          : prev.filter(k => k !== changedItem.key)
      );
    }
    setDropdownValue(changedItem.key?changedItem.key:(changedItem.value?changedItem.value:changedItem.text))
    //setValInp(changedItem)
    setSelectedItem(changedItem);
  };

  useEffect(() => {
  if (selectedItem) {
    let arrayValueDefault = [];
    if (props.defaultSelectedKeys.length > 0) {
      props.defaultSelectedKeys.forEach((element) => {
        arrayValueDefault.push({
          key: element,
          selected: true,
          text: `${element}`,
        });
      });
    }

    let objectFinal = {
      ...(selectedItem ? selectedItem : arrayValueDefault),
      ...{ selectedItem: selectedItem },
      ...{ id: item.key, key: item.id, state: found.disable },
    };

    // Usar setTimeout para evitar ResizeObserver
    const timer = setTimeout(() => {
      props.actionOnChange(objectFinal);
    }, 0);
    
    return () => clearTimeout(timer);
  }
}, [selectedItem]);

  useEffect(() => {
    if (item.defaultValue !== undefined && item.defaultValue !== null) {
      // intentar encontrar la opción que coincide
      const optList = item.options || props.itemsComponentInformation || [];
      const foundOpt = optList.find(o => o.key === item.defaultValue || o.value === item.defaultValue || o.text === item.defaultValue);

      if (foundOpt) {
        setSelectedItem(foundOpt);
        setDropdownValue(foundOpt.key ?? foundOpt.value ?? foundOpt.text);
      } else {
        // si defaultValue es un primitivo (ej 1), ajustar el selectedKey visual
        setDropdownValue(item.defaultValue);
      }
    } else if (item.selectedKey !== undefined) {
      // fallback si usás selectedKey
      setDropdownValue(item.selectedKey);
    }
  }, [item.defaultValue, item.options, props.itemsComponentInformation]);


  const styleSelect = {
    errorMessage:{
      background:'#F5D4D4 0% 0% no-repeat padding-box',
      'border-radius':'4px',
      padding:'7px 7px',
      'margin-top':'2px',
      color:'var(--color-danger)',
      ':before': {
        content: "",
        position: 'absolute',
        left: '10%',
        top: '-20px',
        width: 0,
        height: 0,
        'border-left': '13px solid blue',
        'border-top': '26px solid red',
        'border-right': '13px solid green'
      }
      
    }
  }

  const debouncedDropdownValue = useDebounce(dropdownValue, 100);
  const debouncedDefaultSelectedKeys = useDebounce(props.defaultSelectedKeys, 100);
  
  const errorMessageValue = useMemo(() => {
    return !item.required && !item.isRequired 
      ? undefined : debouncedDropdownValue || debouncedDefaultSelectedKeys.length > 0 
      ? undefined 
      : controlsPage?.slcLanguageTerms?.errorRequiredMessage ?? controlsPage?.slcSelectScheme?.errorRequiredMessage ?? "Seleccione algo de la lista";
  }, [debouncedDropdownValue, debouncedDefaultSelectedKeys, controlsPage]);
  //#endregion
  return (
    <>
    <div className={item.className}>
      <Stack style={item.styleStackFather} id={item.id}>
      <Label>{item.label ? <div style={{position: "relative"}}> <span>{item.label}</span>{item.isRequired || item.required ? <FontIcon aria-label="requerido" iconName="SkypeCircleCheck" className={iconClass} /> : ''} </div> : ""}</Label>
        <Stack style={item.styleStack} id={item.key}>
          <Dropdown
            id={item.key}
            name={item.key}
            key={item.key}
            placeholder={item.placeholder}
            label={item.labelComponent}
            multiSelect={item.multiSelect}
            onChange={onChange}
            options={
              item.options ? item.options : props.itemsComponentInformation
            }
            disabled={item.disable}
            description={item.description}
            // errorMessage={item.errorMessage}
            selectedKey={item.multiSelect ? undefined : item.selectedKey}
            errorMessage={ errorMessageValue }
            styles={item.style?item.style:styleSelect}
            {...(item.multiSelect
              ? { selectedKeys: multiSelectSelectedKeys }
              : { defaultSelectedKeys: item.defaultSelectedKeys, ...( item.defaultValue === null ? {defaultSelectedKey: item.defaultValu} : {defaultSelectedKey: item.defaultValue} ) }
            )}
            //defaultSelectedKey={dropdownValue}
          />
        </Stack>
      </Stack>
      </div>
    </>
  );
};

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debouncedValue;
};

export default React.memo(LargeFormSelect);